import { Link, NavLink } from "react-router-dom"
import ComingSoon from "../../../components/ComingSoon"

export default function AssociationEventsPage() {
    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Events 
                            <span className="text-info text-capitalize" style={{ fontSize: '12px', fontWeight: '500', marginLeft: '10px'}}>
                                (This feature will be available with the next release).
                            </span>
                        </h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Events</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            {1 == 0 ?
                <div className="row" id="contactList">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center border-0">
                                <h5 className="card-title mb-0 flex-grow-1">Events</h5>
                                {/* <div className="flex-shrink-0">
                                    <div className="flax-shrink-0 hstack gap-2">
                                        <button className="btn btn-primary">Today's Orders</button>
                                        <button className="btn btn-soft-info">Past Orders</button>
                                    </div>
                                </div> */}
                            </div>
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-2">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="search-box">
                                            <input type="text" className="form-control search" placeholder="Search events..." />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                    </div>
                                    {/* <!--end col--> */}
                                    {/* <div className="col-xl-3 col-md-6">
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1"><i className="ri-calendar-2-line"></i></span>
                                            <input type="text" className="form-control" data-date-format="d M, Y" data-range-date="true" placeholder="Select date" id="range-datepicker" aria-describedby="basic-addon1" />
                                        </div>
                                    </div> */}
                                    {/* <!--end col--> */}
                                    <div className="col-xl-2 col-md-4">
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon2">From</span>
                                            <input type="date" className="form-control" placeholder="Start Date" />
                                        </div>
                                    </div>
                                    {/* <!--end col--> */}
                                    <div className="col-xl-2 col-md-4">
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon2">To</span>
                                            <input type="date" className="form-control" placeholder="Start Date" />
                                        </div>
                                    </div>
                                    {/* <div className="col-xl-2 col-md-4">
                                        <select className="form-control" name="idStatus" id="idStatus">
                                            <option value="all">Select Membership Status</option>
                                            <option value="Successful">Active</option>
                                            <option value="Cancelled">Expired</option>
                                        </select>
                                    </div> */}
                                    {/* <!--end col--> */}
                                    <div className="col-xl-1 col-md-4">
                                        <button className="btn btn-success w-100" onclick="filterData();">Filters</button>
                                    </div>
                                </div>
                                {/* <!--end row--> */}
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-card">
                                    <table className="table align-middle table-nowrap" id="customerTable">
                                        <thead className="table-light text-muted">
                                            <tr>
                                                <th className="sort" data-sort="serial_number" scope="col">#</th>
                                                <th className="sort" data-sort="event_name" scope="col">Name</th>
                                                <th className="sort" data-sort="event_date" scope="col">Date</th>
                                                <th className="sort" data-sort="location" scope="col">Location</th>
                                                <th className="sort" data-sort="time" scope="col">Time</th>
                                                <th className="sort" data-sort="status" scope="col">Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        {/* <!--end thead--> */}
                                        <tbody className="list form-check-all">
                                            <tr>
                                                <td className="serial_number"><a href="javascript:void(0);" className="fw-medium link-primary">1</a></td>
                                                <td className="event_name link-primary">Club Investiture</td>
                                                <td className="event_date time" data-timestamp="1641945600">02 Jan, 2022</td>
                                                <td className="location">Orlando club house, Ijari</td>
                                                <td className="time">2:20pm</td>
                                                <td className="status">
                                                    <span className="badge bg-success-subtle text-success text-uppercase">Upcoming</span>
                                                </td>
                                                <td>
                                                    <div className="dropdown">
                                                        <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i className="ri-more-fill"></i>
                                                        </button>
                                                        <ul className="dropdown-menu">
                                                            <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</a></li>
                                                            <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-star-fill text-muted me-2 align-bottom"></i>Attend</a></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                            {/* <!--end tr--> */}
                                            <tr>
                                                <td className="serial_number"><a href="javascript:void(0);" className="fw-medium link-primary">2</a></td>
                                                <td className="event_name link-primary">Dinner and Award Night</td>
                                                <td className="event_date time" data-timestamp="1641945600">10 Feb, 2023</td>
                                                <td className="location">Abisola Exclusive hotel</td>
                                                <td className="time">3:00pm</td>
                                                <td className="status">
                                                    <span className="badge bg-success-subtle text-success text-uppercase">Upcoming</span>
                                                </td>
                                                <td>
                                                    <div className="dropdown">
                                                        <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i className="ri-more-fill"></i>
                                                        </button>
                                                        <ul className="dropdown-menu">
                                                            <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</a></li>
                                                            <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-star-fill text-muted me-2 align-bottom"></i>Attend</a></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                            {/* <!--end tr--> */}
                                        </tbody>
                                    </table>
                                    {/* <!--end table--> */}
                                    <div className="noresult" style={{display: "none"}}>
                                        <div className="text-center">
                                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                            <h5 className="mt-2">Sorry! No Result Found</h5>
                                            <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    <div className="pagination-wrap hstack gap-2">
                                        <a className="page-item pagination-prev disabled" href="#">
                                            Previous
                                        </a>
                                        <ul className="pagination listjs-pagination mb-0"></ul>
                                        <a className="page-item pagination-next" href="#">
                                            Next
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--end card--> */}
                    </div>
                    {/* <!--end col--> */}
                </div>
            :
                <ComingSoon />
            }
        </>
    )
}